export const VIEW_OPTIONS = { LIST: 'List', MONTH: 'Calendar' };
